import { Button, Col, Form, Row, Modal } from "../../ui/ot";
import React, { useEffect, lazy, Suspense, useState } from "react";
import BlogCategoryForm from "./blog_category_form";

const BlogCategoryModal = ({
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => { },
    onFinish = () => { },
}) => {
    const axiosModelanguage = {
        post: "新增",
        patch: "修改",
    };
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0);
    const showModal = () => {
        setFormReloadCount((pre) => pre + 1);
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
        if (propsForm) {
            propsForm.submit();
        } else {
            form.submit();
        }
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };

    return (
        <>
            {propsOpen === null && (
                <Button type="primary" onClick={showModal}>
                    {`${axiosModelanguage[axiosMode]}資料`}
                </Button>
            )}

            <Modal
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                width={'500px'}
                contentStyle={{ 
                    padding: 16,
                 }}
                okText={'儲存'}
                cancelText={'取消'}
            >
                <Row
                    gutter={[8, 8]}
                >
                    <Col span={24}>
                    </Col>
                    <Col span={24}>
                        <BlogCategoryForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default BlogCategoryModal;
